import React, {useState} from 'react';
import _uniqueId from 'lodash/uniqueId';
import './Input.scoped.css';
import {
  FieldError,
  FieldErrors,
  FieldName,
  FieldValues,
  RegisterOptions,
  UseFormRegister,
} from 'react-hook-form';
import classNames from 'classnames';

type InputParameters<
  TFieldValues extends FieldValues = FieldValues,
  TFieldName extends FieldName<TFieldValues> = FieldName<TFieldValues>,
> = {
  label?: string;
  name: TFieldName;

  options?: RegisterOptions<TFieldValues, TFieldName>;
  registration: {
    register: UseFormRegister<TFieldValues>;
    errors: FieldErrors<TFieldValues>;
  };
} & React.HTMLAttributes<HTMLElement>;

const Input: <T extends FieldValues = FieldValues>(
  p: InputParameters<T>,
) => React.ReactElement<InputParameters<T>> = ({
  label,
  registration,
  name,
  options,
  ...rest
}) => {
  const [id] = useState(_uniqueId('input-'));

  return (
    <div {...rest}>
      <div className="relative input-component mb-5 cover">
        <input
          id={id}
          type="text"
          className={classNames(
            'h-full w-full px-2 transition-all rounded-sm',
            registration.errors[name] ? 'border-error-300' : 'border-gray-300',
            'focus:border-ffocusoutline',
          )}
          {...registration.register(name, options)}
        />
        {label && (
          <label
            htmlFor={id}
            className="absolute left-2 transition-all bg-white px-1"
          >
            {label}
            {options?.required && <span className="pl-1 text-pink">*</span>}
          </label>
        )}
        {registration.errors[name] && (
          <span className="text-error-600 text-xs">
            {(registration.errors[name] as FieldError | undefined)?.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default Input;
